import { OnSiteSearch } from '../types';

export const onsiteSearchData = (data: OnSiteSearch): OnSiteSearch => ({
  term: data?.term ?? '',
  results: data[data?.filter?.filter] ?? data?.results ?? '',
  ...(data?.resultsPosition && { resultPosition: data?.resultsPosition ?? '' }),
  filter: data?.filter || {
    pagination: 1,
    filter: '',
  },
  searchComponent: data?.searchComponent ?? '',
});
